import type { HistoryDeleteModalTheme } from './types'

/**
 * NovelMello 书架页（History）UI Token
 *
 * 说明：
 * - 能走 UnoCSS 主题变量的（n-primary / n-text-1~3 / n-bg-global / n-bg-card）一律走变量，
 *   由 configs/novelmello.config.ts 注入，这里只放「主题变量表达不了」的渐变与专用浅色。
 * - 数值与 plans/8/新站NovelMello/00-overview.md 的全局 tokens 一致。
 */
export const novelmelloHistoryTheme = {
  /** 主渐变：tab 下划条 / 选中态勾选圈 */
  gradient: 'linear-gradient(90deg, #F0509B 0%, #9B5CF0 100%)',
  /** 辅主色紫：Go to Novel 描边按钮 */
  purple: '#7C4DE8',
  /** 空态大图标色 */
  emptyIcon: '#E3D5EC',
  /** 未选中态的删除按钮 / 弱化紫 */
  mutedPurple: '#D8B6E6',
  /** 白卡通用投影 */
  cardShadow: '0 4px 16px rgba(124, 77, 232, 0.08)',
  /** 底部操作条上投影 */
  barShadow: '0 -2px 12px rgba(124, 77, 232, 0.10)',
  /** 标题字体族（Baloo 2，带系统降级） */
  displayFont: '"Baloo 2", "Nunito Sans", -apple-system, BlinkMacSystemFont, sans-serif',
} as const

/** 删除二次确认弹窗主题（浅底 + 紫浅底取消按钮） */
export const novelmelloDeleteTheme: HistoryDeleteModalTheme = {
  modalBg: '#FFFFFF',
  cancelBg: '#F3EDFE',
  cancelColor: '#71607E',
}
